


























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxTextArea } from 'devextreme-vue/text-area';
import { DxCheckBox, DxSelectBox, DxNumberBox, DxScrollView } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import Contact from '@/classes/CRM/Contact';

import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel, DxTab, DxTabbedItem } from 'devextreme-vue/form';
import cPopup from '@/components/default/Popup.vue';
import { ZipClient } from '@/data/web-api-client';

@Component({
  components: {
    cPopup,
    DxCheckBox,
    DxSelectBox,
    DxNumberBox,
    DxSimpleItem,
    DxGroupItem,
    DxForm,
    DxLabel,
    DxItem,
    DxTextArea,
    DxScrollView,
    DxTab,
    DxTabbedItem,
    DxRequiredRule,
  },
})
export default class ContactDialog extends Vue {
  @Prop({ required: false })
  public relationId?: string;

  public contactId: string | null = null;
  public show?: boolean = false;

  contact: Contact = new Contact();

  async mounted() {
    // Fill up with data from the server
    if (this.contactId) {
      await this.contact.loadData(this.contactId);
    }
  }

  hideDialog() {
    this.$emit('hide');
  }

  async save() {
    try {
      const form: any = this.$refs.contactForm;
      const validationResult = form.instance.validate();

      if (validationResult.isValid) {
        const success = await this.contact.save(this.relationId);
        if (success) {
          this.show = false;
          this.$emit('saved', this.contact);
        }
      } else {
        notificationService.invalidForm();
      }
    } catch {
      notificationService.failedToSave();
    } finally {
      this.contact = new Contact();
      const form: any = this.$refs.contactForm;
      form.instance.resetValues();
    }
  }

  @Watch('contactId')
  onPropertyChanged(value: string, oldValue: string) {
    if (value) {
      if (value) {
        this.contact.loadData(value);
      }
    } else {
      this.contact = new Contact();
    }
  }

  get title() {
    return this.contactId ? this.$t('objects.contacts.EditTitle') : this.$t('objects.contacts.AddTitle');
  }

  get isEditing() {
    return true;
  }

  get languageOptions() {
    const list = this.$store.getters['catalogs/list']('Languages');
    let items = [];
    if (list) {
      items = list.values;
    }

    return {
      items,
    };
  }

  get tagsOptions() {
    const list = this.$store.getters['catalogs/list']('CustomerTags');
    let items = [];
    if (list) {
      items = list.values;
    }

    return {
      items,
    };
  }

  get saving() {
    if (this.contact && this.contact.saving) {
      return true;
    }

    return false;
  }

  get tabbedContent() {
    return [
      {
        itemType: 'tabbed',
        tabPanelOptions: {
          deferRendering: false,
        },
        tabs: [
          // ADDRESS
          {
            title: this.$t('objects.contacts.Subtitles.Address'),
            items: [
              {
                itemType: 'simple',
                dataField: 'address.addressline1',
                label: {
                  text: this.$t('objects.address.Addressline1'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'address.zip',
                editorOptions: this.zipOptions,
                label: {
                  text: this.$t('objects.address.Zip'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'address.city',
                label: {
                  text: this.$t('objects.address.City'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'address.country',
                label: {
                  text: this.$t('objects.address.Country'),
                },
              },
            ],
          },
          // IDENTITY INFORMATION
          {
            title: this.$t('objects.contacts.Subtitles.IdentityInformation'),
            items: [
              {
                itemType: 'simple',
                dataField: 'dateOfBirth',
                editorType: 'dxDateBox',
                editorOptions: { width: '100%' },
                label: {
                  text: this.$t('objects.contacts.Fields.DateOfBirth'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'birthLocation',
                label: {
                  text: this.$t('objects.contacts.Fields.BirthLocation'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'socialSecurityNumber',
                label: {
                  text: this.$t('objects.contacts.Fields.SocialSecurityNumber'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'nationalInsuranceNumber',
                label: {
                  text: this.$t('objects.contacts.Fields.NationalInsuranceNumber'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'nationality',
                label: {
                  text: this.$t('objects.contacts.Fields.Nationality'),
                },
              },
            ],
          },
          // Notes
          {
            title: this.$t('objects.contacts.Subtitles.Notes'),
            items: [
              {
                itemType: 'simple',
                dataField: 'notes',
                editorType: 'dxTextArea',
                editorOptions: { height: 100 },
                label: {
                  text: this.$t('objects.contacts.Fields.Notes'),
                },
              },
            ],
          },
          // Invoicing
          {
            title: 'Kortingen',
            items: [
              {
                itemType: 'simple',
                dataField: 'billingDetails.discountPercentage',
                editorType: 'dxNumberBox',
                label: {
                  text: 'Korting (%)',
                },
              },
            ],
          },
        ],
      },
    ];
  }

  @Watch('show')
  onShowChanged() {
    if (this.show) {
      setTimeout(() => {
        (this.$refs.contactForm as any).instance.getEditor('firstname').focus();
      }, 500);
    }
  }

  get zipOptions() {
    const self = this;
    return {
      onChange: async (e: any) => {
        var result = await new ZipClient(undefined, self.$axios).getCityByZip(self.contact.address.zip);
        if (result) {
          self.contact.address.city = result.hoofdgemeente!;
        } else {
          self.contact.address.city = '';
        }
      },
    };
  }
}
